<template>
  <div 
    :class="wrapperClasses"
  >
    <div v-if="imagePosition === 'full'">
      <content-card
        v-bind="sections[0]"
        :class="imageClass"
      />
    </div>
    <div
      v-else
      :class="featuredRowClass"
    >
      <div :class="imageCardClass">
        <content-card
          v-bind="sections[0].image ? sections[0] : sections[1]"
          :class="imageClass"
        />
      </div>
      <div :class="blogCardClass">
        <blog-card
          :class="blogClass"
          v-bind="!sections[0].image ? sections[0] : sections[1]"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ContentCard from "../card/ContentCard";
import BlogCard from "../card/FeaturedBlogCard";
import isMobile from "@mixins/isMobile";

export default {
  name: "FeaturedRow",
  components: {
    ContentCard,
    BlogCard,
  },
  mixins: [
    //this.isMobile is true screen width < 900px
    isMobile,
  ],
  props: {
    entryTitle: {
      type: String,
      default: "",
    },
    sections: {
      type: Array,
      default: () => [],
    },
    imagePosition: {
      type: String,
      default: "left",
    },
    backgroundColor: {
      type: String,
      default: "white"
    }
  },
  computed: {
    wrapperClasses() {
      let result = ["c-featured-row"];
      if (this.backgroundColor) {
        result.push("c-featured-row--bg-" + this.backgroundColor);
      }
      return result;
    },
    featuredRowClass() {
      let result = [""];
      result.push("c-featured-row--" + this.imagePosition);
      if (this.isMobile) {
        result.push("c-featured-row--mobile");
      } else {
        result.push("c-featured-row--desktop");
      }

      return result;
    },
    imageCardClass() {
      let result = [""];
      if (this.isMobile) {
        result.push("mobile-card");
      } else {
        result.push("c-featured-row--desktop__image-card");
      }

      return result;
    },
    blogCardClass() {
      let result = [""];
      if (this.isMobile) {
        result.push("mobile-card");
      } else {
        result.push("c-featured-row--desktop__content-card");
      }

      return result;
    },
    imageClass() {
      let result = [""];
      if (this.isMobile) {
        result.push("mobile-card");
      } else {
        result.push("c-featured-row--desktop__image-card-content-" + this.imagePosition);
      }

      return result;
    },
    blogClass() {
      let result = [""];
      if (this.imagePosition !== "full") {
        let blogPosition = this.imagePosition == "left" ? "right" : "left";
        if (this.isMobile) {
          result.push("mobile-card-content");
        } else {
          result.push("c-featured-row--desktop__content-card-content-" + blogPosition);
        }
      }

      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
.c-featured-row {
  &--bg-xx-light {
    @include themify($themes) {
      background-color:themed('background', 'xx-light');
    }
  }

  &--bg-white {
    @include themify($themes) {
      background-color:themed('background', 'white');
    }
  }

  &--right {
    flex-direction: row-reverse;
  }

  &--mobile {
    position: relative;
    display: block;
  }

  &--desktop {
    position: relative;
    display: flex;

    &__image-card {
      width: 70%;

      &-content {
        &-left {
          padding-top: 100px;
          padding-bottom: 100px;
          height: calc(100%-rem(200px));
          padding-left: 100px;
        }

        &-right {
          padding-top: 100px;
          padding-bottom: 100px;
          height: calc(100%-rem(200px));
          padding-right: 100px;
        }

        &-full {
          padding-top: 100px;
          padding-bottom: 100px;
          padding-left: 100px;
          padding-right: 100px;
          height: calc(100%-rem(200px));
        }
      }
    }

    &__content-card {
      width: 30%;
      position: relative;
      &-content {
        &-left {
          position: absolute;
          top: 50%;
          transform: translate(100px, -50%);
        }
        &-right {
          position: absolute;
          top: 50%;
          transform: translate(-100px, -50%);
        }
      }
    }
  }
}

.mobile-card {
  width: 100%;
  &-content {
    width: 80%;
    margin: auto;
    transform: translate(0px, -30px);
  }

  ::v-deep {
    .c-content-card__content {
      width: 100%;

      img {
        width: 100% !important;
      }
    }
  }
}

</style>
